/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { JumbotronTypes, LocationTypes } from '@codeparva/gatsby-theme-layout-components';
import { getImageData } from 'utils/getImageData';
import { getDynamicUrl, getUrl } from 'utils/urlUtility';
import { StrapiComponentPagesHomeComponentsHomepageJumbotron } from '../../graphqlTypes';
import { locationMapConfig } from '../locationMap/config';
import {
  buttonText,
  contactDetails,
  facilityGateHours,
  priceSection1,
  reviewLink,
  reviewRating,
} from './Config';
export const getTransformedHours = (hours: any[]) => {
  const hoursToReturn: any = {};
  if (hours && hours.length > 0) {
    hours.forEach(({ open, close, type_of_days }) => {
      const key = type_of_days === 'all' ? 'allDays' : type_of_days;
      if (!hoursToReturn[key]) {
        hoursToReturn[key] = [];
      }
      hoursToReturn[key].push({ open, close });
    });
    return hoursToReturn;
  }
  return null;
};
export const getTransformedButtonText = (
  buttonText: JumbotronTypes.TButtonText[],
  locationDetails: any,
  location_city: any,
  location_state: any,
) => {
  return buttonText.map((button) => {
    const { type, label, link } = button;
    const updatedUrl = getDynamicUrl(link, location_state, location_city);
    return {
      type,
      label,
      link: getUrl(locationDetails, updatedUrl),
    };
  });
};
export const transformLocations = (locationDetails: any): LocationTypes.TLocation[] => {
  const defaultLocations = locationMapConfig.locations;
  if (locationDetails && locationDetails.length > 0) {
    const transformedLocations = locationDetails.map(
      ({ attributes: { location_name, location_contact_details } }: any) => {
        const {
          location_facility_address,
          location_google_maps_place_id,
          location_phone_number,
          location_email_address,
          location_office_hours,
          location_access_hours,
          maps_iframe_url,
        } = location_contact_details;
        return {
          addressText: location_facility_address,
          googleMapPlaceId: location_google_maps_place_id,
          useGoogleMapsContactDetails: true,
          contactNumber: location_phone_number,
          emailAddress: location_email_address,
          facilityName: location_name,
          thumbnail: `${process.env.GATSBY_S3_BASE_URL}/storage-warehouse-1553550_960_720.jpg`,
          hours: {
            officeHrs: getTransformedHours(location_office_hours),
            gateHrs: getTransformedHours(location_access_hours),
          },
          unitStartingPrice: 80,
          iFrameUrl: maps_iframe_url,
        };
      },
    );
    return transformedLocations;
  }
  return defaultLocations;
};
const transformImageData = (data: any) => {
  const transformedGatsbyImageData = data.map((element: any) => {
    return getImageData(element);
  });
  return transformedGatsbyImageData;
};

const transformCardSectionImages = (data: any) => {
  const imageUrls = data.map((singleImage: any) => {
    const { url } = singleImage;
    const transformedGatsbyImageData = getImageData(singleImage);
    return { imageUrl: url, gatsbyImageData: transformedGatsbyImageData };
  });
  return {
    show: true,
    images: imageUrls,
    position: 'left',
    maxWidth: 'full-size',
  };
};
export const transformJumbotronDemo = (
  jumbotronConfig: JumbotronTypes.IJumbotron,
  strapiConfig: StrapiComponentPagesHomeComponentsHomepageJumbotron,
  locationDetails: any,
  facilityDetails: any,
): JumbotronTypes.IJumbotron => {
  const imageSrcFromStrapi = strapiConfig?.background_media?.image;
  const transformedGatsbyImageData = transformImageData(imageSrcFromStrapi);

  let videoSrcFromStrapi;
  if (strapiConfig.background_media?.video?.length > 0) {
    const curVideo = strapiConfig.background_media.video[0];
    videoSrcFromStrapi = {
      src: curVideo.url,
      alt: curVideo.alternativeText || 'video',
    };
  }

  const cardSectionImagesFromStrapi = strapiConfig?.card_section_images?.image;

  let transformedGatsbyCardSectionImageData;
  if (cardSectionImagesFromStrapi) {
    transformedGatsbyCardSectionImageData = transformCardSectionImages(cardSectionImagesFromStrapi);
  }

  const getContactDetails = (): any => {
    const contactDetailsToReturn: any = [];
    if (locationDetails && locationDetails.length > 0) {
      locationDetails.forEach(
        ({
          attributes: { location_name, location_contact_details, location_city, location_state },
        }: any) => {
          const {
            location_facility_address,
            location_phone_number,
            location_office_hours,
            location_access_hours,
            location_google_maps_url,
          } = location_contact_details;
          contactDetailsToReturn.push({
            facilityName: facilityDetails.facility_name,
            locationName: location_name,
            address: [
              {
                icon: {
                  iconClassName: 'FaMapMarkerAlt',
                  size: '',
                  color: 'primary',
                },
                label: '',
                data: location_facility_address,
                link: location_google_maps_url,
              },
            ],
            reviewRating,
            reviewLink,
            contactNumber: [
              {
                icon: {
                  iconClassName: 'FaPhoneAlt',
                  size: '',
                  color: 'primary',
                },
                label: 'Phone Number',
                data: location_phone_number,
                link: `tel:${location_phone_number}`,
              },
            ],
            facilityHours: {
              officeHrs: getTransformedHours(location_office_hours),
              gateHrs: getTransformedHours(location_access_hours),
            },
            priceSection: priceSection1,
            buttonText: getTransformedButtonText(
              buttonText,
              locationDetails,
              location_city,
              location_state,
            ),
            addressText: location_facility_address,
            facilityGateHours,
          });
        },
      );
    }
    return contactDetailsToReturn;
  };
  const getLocationMapConfig = (): LocationTypes.ILocationMap => {
    const locationMapCopy = locationMapConfig;
    locationMapCopy.googleMapAPIKey =
      facilityDetails?.google_my_business_details?.google_maps_api_key;
    locationMapCopy.locations = transformLocations(locationDetails);
    return locationMapCopy;
  };
  return {
    ...jumbotronConfig,
    variant: strapiConfig.jumbotron_variant,
    media: {
      imagesSrc: transformedGatsbyImageData,
      video: videoSrcFromStrapi,
    },
    cardSectionImages: transformedGatsbyCardSectionImageData,
    textOverlay: {
      title: strapiConfig?.text_overlay.title,
      subTitle: strapiConfig?.text_overlay.sub_title,
    },
    locationMapConfig: getLocationMapConfig(),
    contactDetails:
      locationDetails && locationDetails.length > 0 ? getContactDetails() : contactDetails,
    locationDetails,
  };
};
